export default function() {
  const widgetName = 'multiScheduleFeature';
  const widgetOpts = multiScheduleFeatureOpts;
  
  $(`#${widgetName}`).append(`
    <div class="multiScheduleFeature-header">
      <h2>Upcoming Events</h2>  
      <a class="all-events-btn" href="/events.aspx">&gt; View Full Schedule</a>
    </div>
    <div class="mobile-featureContent"></div>
    <div class="swiper-container multiFeatureContent"></div>
    <div class="swiper-button-prev">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M25.4 278.6L2.7 256l22.6-22.6 144-144L192 66.7 237.2 112l-22.6 22.6L125.2 224 416 224l32 0 0 64-32 0-290.7 0 89.4 89.4L237.2 400 192 445.3l-22.6-22.6-144-144z"/></svg>
    </div>
    <div class="swiper-button-next">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M422.6 278.6L445.3 256l-22.6-22.6-144-144L256 66.7 210.8 112l22.6 22.6L322.8 224 32 224 0 224l0 64 32 0 290.7 0-89.4 89.4L210.8 400 256 445.3l22.6-22.6 144-144z"/></svg>
    </div>
    <a class="all-events-btn" href="/events.aspx">&gt; View Full Schedule</a>
  `);

  $(`#${widgetName}`).MultiScheduleFeature({
      scriptPath: widgetOpts.scriptPath
      , currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID
      , detectIpad: IPADDETECTED
      // options
      , allEventsLink: true
      , allEventsLinkText: '&gt; View Full Schedule'
      , hasImages: true
      , imageBackground: true
      , lazyLoadImages: true
      , buyNowButton: {visible: false, text: 'BUY NOW'}
      , moreButton: {visible: false, text: 'MORE'}
      , maxItemsVisible: 20
      , isResponsive: false
      , hasDescription: false
      , textContainer: false
      , link: 'all' //options are 'all', 'text', 'image', 'imageAndText', or ''
      , attributeOrder: {
        1: 'date',
        2: 'image',
        3: 'title',
        4: 'description',
        5: 'buttons'
      }
      , multiFeatureLoaded: function(data){
        // console.log(data);
        // use function below if "more" text needs to appear at end of description text

        $(`#${widgetName} .multiFeatureContent .featureItem .featureItemTitle`).wrap('<div class="mf-title-wrapper"></div>');
        $(`#${widgetName} .multiFeatureContent .featureItem .featureItemDescription`).remove();
        $(`#${widgetName} .multiFeatureContent .featureItem .featureItemImage`).append('<div class="mf-image-hover"><span class="button">Learn More</span></div>');

        const featureItemClones = $(`#${widgetName} .featureItem`).clone();
        featureItemClones.appendTo(`#${widgetName} .mobile-featureContent`);


        $(`#${widgetName} .multiFeatureContent .featureItem`).wrap('<div class="swiper-slide"></div>');
        $(`#${widgetName} .multiFeatureContent .featureItem img`).removeClass('lozad');
        $(`#${widgetName} .multiFeatureContent .featureItem img`).addClass('swiper-lazy');

        $(`#${widgetName} .swiper-slide`).wrapAll('<div class="swiper-wrapper"></div>');


        const multiScheduleFeatureSwiper = new Swiper(`#${widgetName} .multiFeatureContent`, {
          speed: 600,
          spaceBetween: 20,
          preloadImages: false,
          lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 1
          },
          a11y: true,
          autoHeight: true,   
          loop: true,
          slidesPerView: 3,
          centeredSlides: false,
          effect: 'slide',
          navigation: {
            nextEl: `#${widgetName} .swiper-button-next`,
            prevEl: `#${widgetName} .swiper-button-prev`,
          },
          breakpoints: {
            // when window width is >= 320px
            960: {
              slidesPerView: 1
            },
            // when window width is >= 480px
            1366: {
              slidesPerView: 2
            }
          }
        });


        // $('#multiScheduleFeature .featureItem').each(function() {
        //   var itemDescripton = $(this).find('.featureItemDescription');

          // // uncomment below if you need to slice the date string up into something shorter like "Oct 31"
          // var eventDate = $(this).find($('span.featureItemDate'));
          // var datesMonth = eventDate.text().slice(0,3);
          // var datesDay = eventDate.text().slice(4,7).replace(',','');
          // eventDate.text(datesMonth);
          // eventDate.append("<span>"+datesDay+"</span>");

          // // uncomment below if you need to limit the characters in the description text
          // var characterLimit = 120;
          // var itemDescriptonText = itemDescripton.text();
          // if ( itemDescriptonText.length > characterLimit ) {
          //   var trimmedText = itemDescriptonText.substring(0,characterLimit) + '...';
          //   itemDescripton.text(trimmedText);
          // }

          // uncomment below if 'more' link is needed after event description
          // itemDescripton.append("<span class='more-text'>More</span>");
        // });
      }
  });

};

